import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWizardHat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWizardHat"><Path fillRule="evenodd" clipRule="evenodd" d="M11.6323 1.30615L20.5708 9.49982H15.553L19.8712 18.9998H22V20.9998H2V18.9998H4.12585L7.17293 11.8174L7.31578 11.8841L8.1 13.5644L8.88422 11.8841L10.5646 11.0999L8.88422 10.3157L8.32153 9.11L11.6323 1.30615ZM12.3158 14.3157L10.6354 15.0999L12.3158 15.8841L13.1 17.5644L13.8842 15.8841L15.5646 15.0999L13.8842 14.3157L13.1 12.6353L12.3158 14.3157Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWizardHat;
